import { Link } from "@tanstack/react-router";

import useSearchFilters from "../hooks/use-search-filters";

export default function MapOverlay() {
  const { clearUrl } = useSearchFilters();

  return (
    <div className="absolute inset-0 flex flex-col items-center justify-center gap-2.5 bg-light-black/60 px-4 text-white md:gap-0.5">
      <h2 className="text-center font-semibold text-16/[1.4em] md:text-18/[2.29em]">
        These attractions can be enjoyed anywhere
      </h2>
      <p className="text-center text-14/[1.71em]">
        🌎 Want to explore the map?{" "}
        <Link
          className="whitespace-nowrap text-rose-red underline hover:no-underline"
          {...clearUrl()}
        >
          Reset filters
        </Link>
      </p>
    </div>
  );
}
